import { ssp } from 'sveltekit-search-params'

export function getLimitQueryParamKey(namespace: string = '') {
	return namespace ? `${namespace}:limit` : 'limit'
}

export function createLimit(namespace: string = '') {
	return { [getLimitQueryParamKey(namespace)]: ssp.number(25) }
}
